module.exports = __webpack_public_path__ + "img/logo.b1388ba.svg";